import React from 'react';

import { Divider, Button } from '@material-ui/core';
import AppIcon from './AppIcon';
import HorizontalList from '../HorizontalList';
import Separator from '../Separator';

const AppSwitcherMini = (props) => {
    const renderItem = (item) => {
        return <AppIcon title={item.title} targetUrl={item.targetUrl}/>
    };

    let data = props.data ? (props.data.length ? props.data : []) : [];

    return (
        <div style={{ width: "320px" }}>
            <div style={{ padding: "16px" }}>
                <h1 className="wfr-title bold" style={{ margin: 0 }}>Apps</h1>
            </div>

            <Divider />
            <Separator variant="vertical"/>

            <div style={{ padding: "16px" }}>
                <HorizontalList data={data} renderItem={renderItem} />
            </div>
            <Separator variant="vertical" />

            <Button color="primary" style={{ width: "100%" }}>View All</Button>
        </div>
    );
};

export default AppSwitcherMini
